
<style lang="scss" scope>
.ivu-mt,
.ivu-mt-16 {
  margin-top: 16px !important;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.flex {
  display: flex !important;
  width: 100%;
}

.flex-warp {
  flex-wrap: wrap;
}

.mr1 {
  margin-right: 1rem;
  word-wrap: +break-word;
  word-break: +norm;
}

.flexs {
  display: flex !important;
  width: 15%;
}
</style>

<template>
  <el-card shadow="never" class="l-main-card">
    <div class="l-table-toolbar">
      <div class="flex flex-warp">

        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">员工名：</p>
          <el-input placeholder="请输入员工名" v-model="search_data.admin_name" class="input-with-select" style="width: 76%;">
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>

        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属公司：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.corp_id" placeholder="全部" clearable @change="changes" style="width: 100%;">
              <el-option v-for="item in corp_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属部门：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.depart_id" placeholder="全部" clearable @change="changes">
              <el-option v-for="item in depart_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>

        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属小组：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.group_id" placeholder="全部" clearable @change="changes">
              <el-option v-for="item in group_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>

        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">是否获取短码：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.search_state" placeholder="全部" clearable @change="changes">
              <el-option v-for="item in search_state" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>

        <div class="flexs items-center ivu-mt ivu-mr">
          <l-auth-button style="padding: 20px;" :loading="export_loading" type="primary" auth="short_code"
            @click="batchAgree()"> 批量获取短码 </l-auth-button>
        </div>

        <div class="flexs items-center ivu-mt ivu-mr">
          <div class="l-show-more-search" style="width: 100%;">
            <el-button type="default" icon="el-icon-refresh" @click="clearSearch">重置</el-button>
          </div>
        </div>
      </div>
    </div>
    <l-table :data="data" v-loading="loading" row-key="id">
      <el-table-column fixed prop="index" label="序号" width="80"> </el-table-column>
      <el-table-column prop="state" label="状态" min-width="80" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <el-tag :type="row.state == STATES.enabled ? 'success' : 'danger'" size="small" @click="() => changeState(row)"
            disable-transitions>{{
              STATE_NAMES[row.state] }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="username" label="员工名" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="role_name" label="职位" min-width="120" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <el-tag type="danger" size="small" disable-transitions v-if="row.role_type == 2">{{ row.role_name }}</el-tag>
          <el-tag type="warning" size="small" disable-transitions v-if="row.role_type == 3">{{ row.role_name }}</el-tag>
          <el-tag size="small" disable-transitions v-if="row.role_type == 4">{{ row.role_name }}</el-tag>
          <el-tag type="info" size="small" disable-transitions v-if="row.role_type == 5">{{ row.role_name }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="bind_DisplayId" label="邀请码" min-width="200" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="search_no" label="短码" min-width="130" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="depart_name" label="归属部门" min-width="160" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="group_name" label="归属小组" min-width="160" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="created_at" label="注册时间" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column fixed="right" label="操作" min-width="200" align="center">
        <template slot-scope="{ row }">
          <l-auth-text-button type="primary" auth="allocate_info_btn" @click="showInfo(row.id)"><i
              class="el-icon-warning-outline"></i>调配</l-auth-text-button>
          <l-auth-text-button type="primary" auth="search_info_btn" @click="showSearch(row.id)"><i
              class="el-icon-warning-outline"></i>获取短码</l-auth-text-button>
          <!-- <l-auth-text-button type="primary" auth="logs_info_btn" @click="showInfo(row)"><i
                class="el-icon-warning-outline"></i>删除</l-auth-text-button> -->
        </template>
      </el-table-column>
    </l-table>

    <!--分页-->
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size"
      :current-page.sync="page"></l-page>

    <!--详情-->
    <l-dialog :visible.sync="info_visible" title="调配" width="1200px">
      <l-user-info-position @on-success="positionCG" :visible.sync="info_visible" :id="info_id" />
    </l-dialog>

    <!--获取短码-->
    <l-dialog :visible.sync="search_visible" title="获取短码" width="1200px">
      <l-user-info-position @on-success="positiondm" :visible.sync="search_visible" :id="search_id" />
    </l-dialog>

  </el-card>
</template>

<script>
import Vue from "vue";
import { STATES, STATE_NAMES } from "@/common/constants/resources";
import Info from "./Info.vue"
import Search from "./Search.vue"
export default {
  name: "admin-user-position",
  components: {
    [Info.name]: Info,
    [Search.name]: Search,
  },
  data() {
    return {
      export_loading: false,
      info_id: 0,
      info_visible: false,
      search_state: [
        { "id": 1, "name": "否" },
        { "id": 2, "name": "是" }
      ],
      search_visible: false,
      STATE_NAMES: STATE_NAMES,
      STATES: STATES,
      data: [],
      count: 0,
      page: 1,
      search_id: 0,
      page_size: Vue.$_config.page.page_size,
      loading: false,
      //搜索
      total: 0,
      recharge_total: 0,
      transfer_total: 0,
      total_amount: 0,
      search_data: {
        admin_name: "",
        app_type: "",
        start_time: "",
        end_time: "",
        corp_id: "",
        depart_id: "",
        group_id: "",
        search_state: ""
      },
      rel_search_data: {},
      show_more_search: false,
      value2: "",
      value2_check: "",
      corp_list: [],
      depart_list: [],
      group_list: [],
      app_list: []
    };
  },

  mounted() {
    this.getList();
    this.getSearchData();
  },

  methods: {
    getSearchData() {
      // this.loading = true;
      this.$_invoke("adminUser_getSearchData", {
        corp_id: this.search_data.corp_id,
        depart_id: this.search_data.depart_id,
        group_id: this.search_data.group_id,
      })
        .then((ret) => {
          this.corp_list = ret.corp_list;
          this.depart_list = ret.depart_list;
          this.group_list = ret.group_list;
          this.app_list = ret.app_list;
        })
        .finally(() => {
          // this.loading = false;
        });

    },
    // 点击 更改部门
    changes() {
      this.getList();
      this.getSearchData();
    },
    onPick(cant) {
      if (!this.value2) {
        this.value2 = "";
        this.search_data.start_time = "";
        this.search_data.end_time = "";
      } else {
        this.search_data.start_time = this.value2[0];
        this.search_data.end_time = this.value2[1];
      }
      if (!cant) {
        this.onSearch();
      }
    },
    showSearch(admin_id) {
      this.search_id = admin_id;
      this.$nextTick(() => {
        this.search_visible = true;
      });
    },
    //修改状态
    changeState(row) {
      // console.log(row.id);
      this.$_invoke(`adminUser_updState`, {
        id: row.id,
        state: row.state,
      })
        .then((ret) => {
          row.state = ret.state;
          this.$_msg.success("修改状态成功");
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => { });
    },
    batchAgree() {
      this.$confirm(
        "确定批量未获取短码的员工吗" + "？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.export_loading = true;
          this.$_invoke(`userPosition_allSearch`, {}).then(() => {
            this.$_msg.success("操作成功");
            this.getList();
            this.export_loading = false;
          });
        })
        .catch(() => { });
    },
    //获取数据
    getList() {
      this.loading = true;
      this.$_invoke("userPosition_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.search_data,
      })
        .then((ret) => {
          // console.log(ret.data);
          this.data = ret.data;
          this.count = ret.count;
          //this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //显示详情
    showInfo(id) {
      this.info_id = id;
      this.$nextTick(() => {
        this.info_visible = true;
      });
    },
    //调配完成 
    positionCG() {
      this.info_visible = false;
      this.getList();
    },

    positiondm() {
      this.search_visible = false;
      this.getList();
    },
    //清除搜索数据
    clearSearch() {
      this.search_data.admin_name = "";
      this.search_data.app_type = "";
      this.search_data.corp_id = "";
      this.search_data.depart_id = "";
      this.search_data.group_id = "";
      this.search_data.end_time = "";
      this.search_data.start_time = "";
      this.search_data.start_time = "";
      this.corp_list = [];
      this.depart_list = [];
      this.group_list = [];
      this.app_list = [];
      this.getList();
      this.getSearchData();
    },
  },
};
</script>
